import React from 'react'
import { toast } from 'components/global/CUK/Toast/Toast'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useMutation } from '@apollo/client'

import ActionModal from 'components/Modal/ActionModal'
import { trackEvent } from 'analytics'

import {
  OPERATION_CHECKOUT_ROOM,
} from '../operations-gql'
import { Room, useRoom } from '../use-rooms'

export const CheckoutModal = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const room: Room | undefined = useRoom()
  const location = useLocation()
  const navigate = useNavigate()

  const [checkout, { loading }] = useMutation(OPERATION_CHECKOUT_ROOM, {
    variables: {
      sf_id: room?.site_sf_id,
      room_id: Number(id),
    },
    onError: () => {
      trackEvent('stream_cast_action_failed', { action: 'checkout' })
      toast.error(t('stream-cast.actions.checkout_modal.toast_error'))
    },
    onCompleted: () => {
      trackEvent('stream_cast_room_checked_out')
      toast.success(t('stream-cast.actions.checkout_modal.toast_success'))
      navigate(`..${location.search}`)
    }
  })

  return (
    <ActionModal
      cancelLabel={t('ui_elements.cancel')}
      confirmColor="primary"
      confirmLabel={t('ui_elements.confirm')}
      description={t('stream-cast.actions.checkout_modal.body', { name: room?.name })}
      icon={<i className="fa-light fa-arrow-right-from-bracket" />}
      loading={loading}
      onClose={() => navigate(`..${location.search}`)}
      onConfirm={() => checkout()}
      title={t('stream-cast.actions.checkout_modal.title')}
      variant="primary"
    />
  )
}

export default CheckoutModal
